import { useState } from "react";
import {
  useFloating,
  useDismiss,
  useInteractions,
  offset,
  autoPlacement,
  Placement,
  useHover,
} from "@floating-ui/react";
import { autoUpdate } from "@floating-ui/react-dom";

export interface UseFloatingCardOptions {
  placement?: Placement;
  middleware?: any[];
}

export function useFloatingCard(options: UseFloatingCardOptions = {}) {
  const {
    placement = "left-start",
    middleware = [offset(20), autoPlacement({
      allowedPlacements: ["right-start", "left-start"]
    })],
  } = options;

  const [open, setOpen] = useState(false);
  const [activeReference, setActiveReference] = useState<HTMLElement | null>(null);

  const { refs, floatingStyles, context } = useFloating({
    open,
    onOpenChange: setOpen,
    placement,
    middleware,
    elements: { reference: activeReference },
    whileElementsMounted: autoUpdate,
  });

  const hover = useHover(context, {
    move: true, // 只在enter/leave时触发
    restMs: 100, // 悬停到弹出层时的宽容时间
    delay: { open: 100, close: 300 },
  });
  const dismiss = useDismiss(context);
  const {
    getReferenceProps,
    getFloatingProps,
  } = useInteractions([
    hover,
    dismiss,
  ]);

  // 触发区的props
  const getReferenceHoverProps = (callback?: (evt: React.MouseEvent) => void) => ({
    ...getReferenceProps({
      onMouseEnter: (evt: React.MouseEvent) => {
        setActiveReference(evt.currentTarget as HTMLElement);
        callback?.(evt);
      },
    })
  });


  return {
    open,
    setOpen,
    activeReference,
    setActiveReference,
    refs,
    floatingStyles,
    getReferenceHoverProps,
    getFloatingHoverProps: getFloatingProps,
  };
} 